import { render } from "./FoundersSlides.vue?vue&type=template&id=431eaf84&scoped=true"
import script from "./FoundersSlides.vue?vue&type=script&lang=js"
export * from "./FoundersSlides.vue?vue&type=script&lang=js"

import "./FoundersSlides.vue?vue&type=style&index=0&id=431eaf84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-431eaf84"]])

export default __exports__